import { type TFunction } from "i18next";
import { z } from "zod";

export const MAX_TEXT_LENGTH = 1000;

export const preApproveSchema = (t: TFunction) =>
  z.object({
    files: z.any().optional(),
    internalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.internal-notes"),
          max: 1000,
        }),
      )
      .optional(),
    externalNotes: z
      .string()
      .max(
        1000,
        t("form-validation.max-length", {
          label: t("vessel-call.common.external-notes"),
          max: 1000,
        }),
      )
      .optional(),
  });

export type PreApproveSchema = z.infer<ReturnType<typeof preApproveSchema>>;
